module.exports = __webpack_public_path__ + "static/media/sales-landscape.8a9413f5.jpg";